export const chaosMap = {
    title: 'Chaosmap',
    tooltip:
        'Users can understand the chaos map by displaying what kind of players exist for each element of the value chain and technology cluster.',
    table: 'Chaos map by Cluster',

    nace: 'Process',
    name: 'Company'
}
